module.exports = __webpack_public_path__ + "img/s_fwt20-logo.fa3334b.png";